import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useState } from 'react';

const TimeBuffHistory = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.TimeBuffHistory;
  const [history, setHistory] = useState<[]>([]);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = async () => {
    const result = await ItemDataManager.getItemHistoryByCategory('timeBuff');
    setHistory(result);
  };

  return (
    <div className="flex h-full w-full flex-col items-center">
      <div className="mb-8 typography-title-md text-dialog-txt-default">{brsc.activity_log}</div>
      <div className="mb-12 flex w-full flex-auto flex-col overflow-y-auto">
        {history.length > 0 &&
          history.map((item: any) => (
            <div key={item._id} className="flex w-full flex-row items-center justify-between py-2">
              <div className="typography-headline-md text-dialog-txt-default">{`${TimeUtil.getYYMMDDFromDate(item.usedAt)} / ${TimeUtil.getHHMMSSFromDate(item.usedAt)}`}</div>
              <div className="text3 text-dialog-txt-secondary">{brsc.item_usage_completed}</div>
            </div>
          ))}
        {history.length === 0 && <div className="flex flex-auto items-center justify-center text-center text-dialog-txt-default">no list</div>}
      </div>
      <Button onClick={() => close(sheet.id)} className="mt-4 w-full" style={{ text: brsc.close, color: 'btn-bg-normal', fontColor: 'btn-txt-secondary' }} />
    </div>
  );
};

export default TimeBuffHistory;
